import backbone from 'backbone';
import _ from 'underscore';

/**
 * BulkEditJobModel, provides base model for bulk edit job
 * Can be used (extended for override purpose) for bulk actions like automated rules & bulk edit
 */
export class BulkEditJobModel extends backbone.Model {
  /**
   * Initialize model settings
   * @param {Object} param - An object containing these default options for model
   * @param {Object} param.odata - odata module
   * @param {string} param.odata.jq_ajax_adapter - the function for ajax action
   *
   * @returns {void} void
   */
  initialize({ odata }) {
    this.options = { odata };

    super.initialize(this.options);
    this.idAttribute = 'id';
  }

  /**
   * Default settings for the model
   *
   * @returns {void} void
   */
  defaults() {
    return {
      Id: null,
      Selection: '',
      TotalRowCount: 0,
      SuccessRowCount: 0,
      ErrorRowCount: 0,
      Status: '',
      CreationTime: '',
      ExecutionStartTime: '',
      CompletionTime: '',
      CreatedBy: '',
      Description: '',
      BulkEditResults: [],
      selectedEntityCount: 0,
      PreviewEntityIds: [],
    };
  }

  /**
   * parse response and convert it into model content
   * @param {Object} response - response object
   *
   * @returns {Object} prased object
   */
  parse(response) {
    if (response) {
      const result = _.pick(
        response,
        'Selection',
        'Description',
        'TotalRowCount',
        'SuccessRowCount',
        'ErrorRowCount',
        'Status',
        'CreationTime',
        'ExecutionStartTime',
        'CompletionTime',
        'CreatedBy',
        'BulkEditResults'
      );

      result.Id = response.Id && response.Id.length > 0 ? response.Id : null;

      return result;
    }

    return undefined;
  }

  /**
   * model sync settings, have different setting for different type of operation
   * @param {String} method - operation name
   * @param {String} model - model
   * @param {Object} options - addtional options
   *
   * @returns {void} void
   */
  sync(method, model, options) {
    const url = _.template(this.url)({
      jobId: this.get('Id'),
    });

    if (method === 'create') {
      options.type = 'Post'; // eslint-disable-line no-param-reassign
      options.data = JSON.stringify({ // eslint-disable-line no-param-reassign
        Entity: model.get('Entity'),
        BatchAction: model.get('BatchAction'),
        Selection: model.get('Selection'),
        Description: model.get('Description'),
        PreviewEntityIds: model.get('PreviewEntityIds'),
      });
    } else {
      options.type = 'Get'; // eslint-disable-line no-param-reassign
    }

    // TODO: apjia, track usage of jq_ajax_adapter and see whether we can repace it
    // with Assets/component/http/js/channel/core
    return this.options.odata.jq_ajax_adapter.call(this, url, options);
  }
}
